import MDModal from "components/MDModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useContext, useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { ModalContext } from "context/ModalContext";
import { LoginFormContext } from "context/LoginFormContext";
import { MODULES, SEARCH_INPUT_TYPES } from "helpers/constant";
import UpdateStatus from "components/MDUpdateStatus";
import MDActionButton from "components/MDActionButton";
import { occasionList, getOccasionById, deleteOccasionById, updateOccasion } from "Apis/occasion";
import OccasionForm from "./Form";
import { OccasionContext } from "context/OccasionContext";
const Occasion = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const { setNotification, modules, getModuleAccess, access, isLoading, setFilterLoader } =
    useContext(LoginFormContext);
  const { setEditData } = useContext(OccasionContext);

  const [occasionData, setOccasionData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });
  const [filterVal, setFilterVal] = useState({ name: "" });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      name: filterVal?.name,
      is_active: filterVal?.is_active?.value,
    },
  };

  const getOccasionList = async () => {
    let response = await occasionList(Obj);
    if (response?.status === 200) {
      setOccasionData(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
    }
  };

  const handleEditDelete = async (row, type) => {
    if (type === "Edit") {
      setFilterLoader(false);
      let response = await getOccasionById(row.id);
      if (response?.status === 200) {
        setEditData(response?.data?.data);
        setOpen(true);
        setFormIsEdit(true);
      }
    }

    if (type === "Delete") {
      showMessageNotification({
        title: "Are you sure?",
        text: "You want to delete this occasion!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result?.isConfirmed) {
          let deleteResponse = await deleteOccasionById(row.id);
          if (deleteResponse?.status === 200) {
            setFilterLoader(false);
            setOpen(false);
            occasionData?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
            getOccasionList();
            setNotification({
              color: "success",
              icon: "check",
              title: "Success",
              content: deleteResponse?.data?.message,
              open: true,
            });
          } else {
            setNotification({
              color: "error",
              icon: "cancel",
              title: "Error",
              content: deleteResponse?.data?.message,
              open: true,
            });
          }
        }
      });
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.AMENITY);
  }, [modules]);

  useEffect(() => {
    getOccasionList();
  }, [filterVal, defaultFilter]);

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "Name",
        accessor: "name",
        minWidth: "85px",
        sort: true,
        filterLabel: "Name",
        filterAccessor: "name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Description",
        accessor: "description",
        minWidth: "85px",
        sort: false,
        Cell: ({ value }) => {
          if (!value) return "-";

          // Remove HTML tags to count/display plain text
          const plainText = value?.replace(/<[^>]+>/g, "");

          const truncatedText =
            plainText.length > 50 ? `${plainText.substring(0, 50)}...` : plainText;

          return <div style={{ maxWidth: "400px" }}>{truncatedText}</div>;
        },
      },
      {
        Header: "Status",
        accessor: "is_active",
        sort: false,
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="occasions"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEditDelete(row?.original, "Edit")} />
            )}
            {access?.delete_access && (
              <MDActionButton
                type="delete"
                onClick={() => handleEditDelete(row?.original, "Delete")}
              />
            )}
          </MDBox>
        ),
      },
    ],
    rows: occasionData,
  };

  return (
    !isLoading && (
      <DashboardLayout>
        <DashboardNavbar />
        <>
          <MDModal
            hasButton={access?.write_access ?? false}
            btnText="Add Occasion"
            modalHead={`${formIsEdit ? "Edit" : "Add"} Occasion`}
          >
            <OccasionForm getOccasionList={getOccasionList} />
          </MDModal>
          <DataTable
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            canSearch={true}
            tableTitle="Occasion List"
            updateApi={updateOccasion}
            getDataList={getOccasionList}
            rowCount={rowCount}
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
        </>
      </DashboardLayout>
    )
  );
};

Occasion.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
};

export default Occasion;
